import { PresetOptionEnum } from '@app/core/constants/date_presets.enum';

interface IDateRange {
  start: Date;
  end: Date;
}

export function getOffsetDate(days: number): Date {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
}

function getFirstDayOfWeekOffset(day: Date): number {
  const weekday: number = day.getDay(); // Sunday = 0
  return weekday === 0 ? 6 : weekday - 1; // Mon = 0, Sun = 6
}

export function addMonths(date: Date, months: number): Date {
  const result: Date = new Date(date);
  const expectedDay: number = result.getUTCDate();

  result.setUTCMonth(result.getUTCMonth() + months);

  // If the day changed and it has overflowed then set the date to the last day of the intended month
  // This allows us to handle cases where the day overflows
  // (e.g., Jan 31 + 1 month should be Feb 28/29, not Mar 3)
  if (result.getUTCDate() !== expectedDay) {
    result.setUTCDate(0);
  }

  return result;
}

export function getDateRangeFromPreset(preset: PresetOptionEnum): IDateRange {
  const today = new Date();

  const presetRanges: Record<PresetOptionEnum, IDateRange> = {
    [PresetOptionEnum.Today]: { start: today, end: today },
    [PresetOptionEnum.Yesterday]: {
      start: getOffsetDate(1),
      end: getOffsetDate(1),
    },
    [PresetOptionEnum.ThisWeek]: {
      start: getOffsetDate(getFirstDayOfWeekOffset(today)),
      end: today,
    },
    [PresetOptionEnum.Last7Days]: {
      start: getOffsetDate(6),
      end: today,
    },
    [PresetOptionEnum.Last30Days]: {
      start: getOffsetDate(29),
      end: today,
    },
    [PresetOptionEnum.Last90Days]: {
      start: getOffsetDate(89),
      end: today,
    },
    [PresetOptionEnum.Last365Days]: {
      start: getOffsetDate(364),
      end: today,
    },
  };

  return presetRanges[preset];
}

export function endOfDay(date: Date): Date {
  return new Date(
    Date.UTC(
      date.getUTCFullYear(), // year
      date.getUTCMonth(), // month
      date.getUTCDate(), // day
      23, // hour
      59, // minute
      59, // second
      999, // millisecond
    ),
  );
}

export function startOfDay(date: Date): Date {
  return new Date(
    Date.UTC(
      date.getUTCFullYear(), // year
      date.getUTCMonth(), // month
      date.getUTCDate(), // day
      0, // hour
      0, // minute
      0, // second
      0, // millisecond
    ),
  );
}
